import type { ReactNode } from 'react'

import { clsx } from 'clsx'

interface LoadingOverlayProps {
  isLoading: boolean
  pulse?: boolean
  children: ReactNode
}
export const LoadingOverlay = ({
  isLoading,
  pulse = true,
  children,
}: LoadingOverlayProps) => {
  if (isLoading) {
    return (
      <div className={clsx('relative opacity-30', pulse && 'animate-pulse')}>
        <div
          className="absolute inset-0 cursor-default z-50"
          onClick={e => {
            e.stopPropagation()
            e.preventDefault()
          }}
        ></div>
        {children}
      </div>
    )
  }

  return <>{children}</>
}
